function PageNotFound() {
    return <h3>존재하지 않는 페이지입니다.</h3>
}

export default PageNotFound;